import CitySEOHead from "@/components/feature/CitySEOHead";
import SEOCrossLinks from "@/components/feature/SEOCrossLinks";
import RoswellHeroSection from "./components/HeroSection";
import RoswellStickyNav from "./components/StickyNav";
import RoswellProcessingTimeSection from "./components/ProcessingTimeSection";
import RoswellServicesSection from "./components/ServicesSection";
import RoswellLocalAreaSection from "./components/LocalAreaSection";
import RoswellTestimonialsSection from "./components/TestimonialsSection";
import RoswellAcceptanceFacilitiesSection from "./components/AcceptanceFacilitiesSection";
import RoswellComparisonSection from "./components/ComparisonSection";
import RoswellMistakesSection from "./components/MistakesSection";
import RoswellHowItWorksSection from "./components/HowItWorksSection";
import RoswellFAQSection, { faqs } from "./components/FAQSection";
import RoswellHelpfulResourcesSection from "./components/HelpfulResourcesSection";
import RoswellFinalCTA from "./components/FinalCTA";

const servicesList = [
  { name: "Emergency Passport", description: "Urgent passport processing for travelers with immediate departure needs, as fast as 24 hours." },
  { name: "Passport Renewal", description: "Fast passport renewal for U.S. citizens with a passport issued within the last 15 years at age 16 or older." },
  { name: "New Passport", description: "First-time passport application assistance with step-by-step guidance through the acceptance clerk process." },
  { name: "Lost or Stolen Passport", description: "Passport replacement service for lost or stolen passports, including DS-64 form guidance." },
  { name: "Child Passport", description: "Passport services for minors under 16, with parental consent guidance and acceptance clerk support." },
  { name: "Name Change", description: "Passport correction and name change service after marriage, divorce, or legal name changes." },
  { name: "Second Passport & Damaged", description: "Second passport issuance for frequent travelers and damaged passport replacement." },
];

export default function RoswellPage() {
  return (
    <div className="font-sans">
      <CitySEOHead
        city="Roswell"
        state="Georgia"
        stateAbbr="GA"
        route="/roswell"
        title="Emergency Passport Roswell, GA — Expedited & Fast Passport Service | Fast Passport Center"
        description="Emergency and expedited passport services in Roswell, GA — as fast as 24 hours. Same-day courier processing available. A+ BBB rated, registered State Dept. courier serving north metro Atlanta travelers. Get your emergency passport fast!"
        keywords="expedited passport, emergency passport, Roswell passport, same day passport Atlanta, fast passport Georgia"
        geoPlacename="Roswell, Georgia"
        geoPosition="34.0232;-84.3616"
        faqs={faqs}
        servicesSchema={servicesList}
        statePageName="Georgia"
        statePageRoute="/states/georgia"
      />
      <RoswellHeroSection />
      <RoswellStickyNav />
      <RoswellProcessingTimeSection />
      <RoswellServicesSection />
      <RoswellLocalAreaSection />
      <RoswellTestimonialsSection />
      <RoswellAcceptanceFacilitiesSection />
      <RoswellComparisonSection />
      <RoswellMistakesSection />
      <RoswellHowItWorksSection />
      <RoswellFAQSection />
      <RoswellHelpfulResourcesSection />
      <SEOCrossLinks currentRoute="/roswell" state="GA" />
      <RoswellFinalCTA />
    </div>
  );
}